/**
 * URL security utilities for the frontend.
 */

const ALLOWED_IMAGE_PROTOCOLS = new Set(['http:', 'https:', 'blob:', 'data:']);
const BLOCKED_PROTOCOLS = new Set(['javascript:', 'vbscript:', 'file:']);

/**
 * Validate that a URL is safe to assign to an <img> src or similar DOM property.
 */
export function isSafeImageUrl(url: string | undefined | null): boolean {
  if (!url) return false;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    // Fallback for relative URLs or URLs without a protocol.
    // Reject any string that starts with a dangerous protocol prefix.
    const lower = url.trim().toLowerCase();
    if (lower.startsWith('javascript:') || lower.startsWith('vbscript:') || lower.startsWith('file:')) {
      return false;
    }
    // Reject data URIs that are not images (e.g. data:text/html)
    if (lower.startsWith('data:')) {
      const mime = lower.split(';')[0].slice(5); // remove 'data:' prefix
      if (!mime.startsWith('image/')) return false;
    }
    return true;
  }

  const protocol = parsed.protocol.toLowerCase();
  if (BLOCKED_PROTOCOLS.has(protocol)) return false;
  if (!ALLOWED_IMAGE_PROTOCOLS.has(protocol)) return false;

  // Reject data URIs that carry HTML/JS MIME types
  if (protocol === 'data:') {
    const mime = parsed.pathname.split(';')[0].toLowerCase();
    if (!mime.startsWith('image/')) return false;
  }

  return true;
}
